import React from 'react';
import { Mutation } from '@apollo/client/react/components';

import FlagItemMutation from 'buyside/graphql/mutations/FlagItem.graphql';

import FlagCompensation from 'buyside/components/presentation/CompensationIndexPage/CompensationCard/FlagCompensation/flagCompensation';

const FlagCompensationContainer = ({ id }) => {
  return (
    <Mutation mutation={FlagItemMutation}>
      {mutate => {
        const handleFlag = () =>
          mutate({
            variables: {
              itemId: id,
              category: 'content',
              description: 'Flag as inappropriate/inaccurate',
              type: 'Compensation'
            }
          });
        return <FlagCompensation handleFlag={handleFlag} />;
      }}
    </Mutation>
  );
};

export default FlagCompensationContainer;
